import React from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import TitleAllProduct from "./TitleAllProduct";
import Allproduct2 from "./Allproduct2";

const Allproduct = () => {
    return (
      <>
        <Header />
        <TitleAllProduct />
        <Allproduct2 />
        <Footer />
      </>
    );
  };
  
export default Allproduct;
